<template>
    <div class="configurations-container">
        <template v-if="isLoadingStartingData">
            <SpeenComponent style="padding: 5ch 0;" :isAutomatic="true" :ringWidth="14" :spinnerSize="15"
                :isverticalAligned="true" />
        </template>
        <template v-else>
            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-header-content">Configuraciones generales</h3>
                    </div>
                    <div class="card-body">
                        <div class="card-body-section">
                            <h5 class="card-body-section-content">Refrescar los valores de la configuración general</h5>
                            <button class="general-button general-button-refresh"
                                @click="getStartingData()">Refrescar</button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-header-content">Machine records</h3>
                    </div>
                    <div class="card-body">
                        <div class="card-body-section">
                            <h5 class="card-body-section-content">Restablecer los valores de unidad de los registros de
                                la máquina</h5>
                            <button class="general-button" @click="resetMachineValues()">Restablecer</button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-header-content">Límite de sesiones</h3>
                    </div>
                    <div class="card-body">
                        <div class="card-body-section is-user-session-limit-active-section">
                            <h5 class="card-body-section-content">Habilitar limitación de cantidad de sesiones de
                                usuario simultáneas</h5>
                            <button class="general-button"
                                :class="userSessionLimitActive ? 'general-button-danger' : 'general-button-success'"
                                @click="toggleUserSessionLimitActive()">
                                {{ userSessionLimitActive ? 'Deshabilitar' : 'Habilitar' }}
                            </button>
                        </div>
                        <hr>
                        <div class="card-body-section">
                            <h5 class="card-body-section-content">Cantidad de sesiones de usuario simultáneas
                                permitidas:
                                <span v-if="userSessionLimitActive" class="configuration-changing-value">
                                    <button class="general-button"
                                        @click="decrementMaxUserSessions" :disabled="maxUserSessions <= 1"
                                        aria-label="Disminuir">-</button>
                                    {{ maxUserSessions }}
                                    <button class="general-button"
                                        @click="incrementMaxUserSessions" aria-label="Aumentar">+</button>
                                </span>
                                <span v-else class="text-muted"> (Deshabilitado)</span>
                            </h5>
                            <button class="general-button" v-if="userSessionLimitActive"
                                @click="updateMaxUserSessions()" :disabled="maxUserSessions < 1"
                                aria-label="Cambiar cantidad de sesiones de usuario">
                                Cambiar cantidad
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="slide-fade">
                <ActionConfirmModal v-if="showActionConfirmModal" :contentMessage="contentMessage"
                    :closeModal="closeModal" :methodForProp="methodForProp" />
            </transition>
        </template>
    </div>
</template>

<script>

import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils.js';

export default {
    name: "SuperadminConfigurations",
    components: {
        ActionConfirmModal,
        SpeenComponent,
    },
    data() {
        return {
            isLoadingStartingData: true,
            showActionConfirmModal: false,
            contentMessage: "",
            methodForProp: "",
            userSessionLimitActive: false,
            maxUserSessions: 0,
        };
    },
    methods: {
        resetMachineValues() {
            this.methodForProp = this.resetMachineValuesFunction;
            this.contentMessage = '¿Restablecer valores de unidad de los records?';
            this.showActionConfirmModal = true;
        },
        resetMachineValuesFunction() {
            axios.patch('/api/superadmin/configurations/restore-machine-records')
                .then(response => {
                    showCustomSuccessSweetAlert('Los records de la máquina han sido restablecidos correctamente.');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.showActionConfirmModal = false;
                });
        },
        closeModal() {
            this.showActionConfirmModal = false;
        },
        getStartingData() {
            this.isLoadingStartingData = true;
            axios.get('/api/superadmin/configurations/starting-data')
                .then(response => {
                    this.userSessionLimitActive = response.data.userSessionLimitActive;
                    this.maxUserSessions = response.data.maxUserSessions;
                    this.isLoadingStartingData = false;
                })
                .catch(error => {
                    console.error('Error fetching starting data:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        toggleUserSessionLimitActive() {
            this.methodForProp = this.toggleUserSessionLimitActiveFunction;
            this.contentMessage = this.userSessionLimitActive
                ? '¿Deshabilitar la limitación de sesiones de usuario?'
                : '¿Habilitar la limitación de sesiones de usuario?';
            this.showActionConfirmModal = true;
        },
        toggleUserSessionLimitActiveFunction() {
            axios.patch('/api/superadmin/configurations/change-user-session-limit-active', {
                userSessionLimitActive: !this.userSessionLimitActive
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Configuración actualizada correctamente.');
                    this.userSessionLimitActive = !this.userSessionLimitActive;
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.showActionConfirmModal = false;
                });
        },
        incrementMaxUserSessions() {
            this.maxUserSessions++;
        },
        decrementMaxUserSessions() {
            if (this.maxUserSessions > 1) {
                this.maxUserSessions--;
            }
        },
        updateMaxUserSessions() {
            this.methodForProp = this.updateMaxUserSessionsFunction;
            this.contentMessage = `¿Cambiar la cantidad de sesiones de usuario simultáneas a ${this.maxUserSessions}?`;
            this.showActionConfirmModal = true;
        },
        updateMaxUserSessionsFunction() {
            axios.patch('/api/superadmin/configurations/change-max-user-sessions', {
                maxUserSessions: this.maxUserSessions
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Cantidad de sesiones de usuario actualizada correctamente.');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.showActionConfirmModal = false;
                });
        },
    },
    mounted() {
        this.getStartingData();
    },
};
</script>